import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { OpportunityLostReasonType } from '@fitness-force/enum';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'lost-reason-type',
  templateUrl: './lost-reason-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class LostReasonTypeComponent {
  readonly additionData = input(new BehaviorSubject(null));
  readonly columnData = input(new BehaviorSubject(null));
  type!: any;

  getLostReasonType(value: any) {
    if (typeof value === 'number' || !isNaN(Number(value))) {
      return OpportunityLostReasonType[Number(value)];
    }
    return value;
  }
}
